




































































import '../styles/agent-resources.css'
import { Vue } from 'vue-property-decorator'

import ScreenTile from '../components/ScreenTile.vue'
import ResourceRow from '../components/ResourceRow.vue'
import ResourceDirectoryTile from '../components/ResourceDirectoryTile.vue'
import Breadcrumbs from '../components/general/Breadcrumbs.vue'
import * as _ from 'lodash'

import { mapState } from 'vuex'

interface IFavorite {
  id: number
  username: string
  reinsruanceResourcePath: string
}

interface IReinsuranceResource {
  name: string
  numberOfChildren: number
  favorite?: { id: number; reinsruanceResourcePath: string }
  path: string
}

interface IModel {
  loading: boolean
  searchText: string
  reinsuranceResources: IReinsuranceResource[]
  favorites: IFavorite[]
  routes: any[]
  currentPath: string
}

export default Vue.extend({
  data: function (): IModel {
    return {
      loading: true,
      favorites: [] as IFavorite[],
      reinsuranceResources: [] as IReinsuranceResource[],
      searchText: '',
      routes: [{ id: '', name: 'Reinsurance Resources' }] as {
        id: string | undefined
        name: string
      }[],
      currentPath: '/',
    }
  },
  methods: {
    debounceSearch: _.debounce(function (searchText) {
      this.search(searchText)
    }, 500),
    recurseUpTo: async function (path: string) {
      this.loading = true

      const indexOfRoute = this.routes.findIndex((x) => x.id === path)
      this.routes = this.routes.slice(0, indexOfRoute + 1)

      this.reinsuranceResources = await (
        await fetch(`/api/reinsuranceresources?path=${encodeURIComponent(path)}`)
      ).json()

      this.currentPath = path
      this.loading = false
    },
    search: async function (searchText: string) {
      this.reinsuranceResources = []
      this.loading = true
      if (searchText === '')
        this.reinsuranceResources = await (
          await fetch(`/api/reinsuranceresources?path=${encodeURIComponent(this.currentPath)}`)
        ).json()
      else
        this.reinsuranceResources = await (
          await fetch(`/api/reinsuranceresources/search?search=${encodeURIComponent(searchText)}&currentPath=${encodeURIComponent(this.currentPath)}`)
        ).json()
      this.loading = false
    },
    descendIntoDirectory: async function (name: string) {
      this.loading = true
      const newPath = (this.currentPath + '/').replace('//', '/') + name
      this.routes.push({
        id: newPath,
        name: name ?? '',
      })
      this.$router.push({
        name: 'Reinsurance Resources',
        params: { path: newPath },
      })
      this.currentPath = newPath
      this.reinsuranceResources = await (
        await fetch(`/api/reinsuranceresources?path=${encodeURIComponent(newPath)}`)
      ).json()

      this.loading = false
    },
    openDocument: async function (document: { path: string }) {
      let path = document.path
      if(path.startsWith('/')){
        path = path.substring(1)
      }
      const encodedPath  = encodeURIComponent(path)
      window.open(
        `/api/reinsuranceresources/download?path=${encodedPath}`
      )
    },

    toggleFavorite: async function (params: {
      favoriteId?: number
      path?: string
    }) {
      if (params.favoriteId) {
        const response = await fetch(`/api/favorites/${params.favoriteId}`, {
          method: 'DELETE',
        })

        if (response.ok)
          this.favorites = this.favorites.filter(
            (favorite: IFavorite) => favorite.id !== params.favoriteId
          )
      } else if (params.path) {
        const response = await fetch('/api/favorites', {
          method: 'POST',
          body: JSON.stringify({
            reinsruanceResourcePath: params.path,
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })

        if (response.ok) this.favorites.push(await response.json())
      }
    },
  },
  computed: {
    reinsuranceResourcesWithFavorites(): IReinsuranceResource[] {
      return this.reinsuranceResources.map(
        (mdresource: IReinsuranceResource) => {
          const favorite = this.favorites.find(
            (favorite: IFavorite) =>
              favorite.reinsruanceResourcePath ===
              `${this.currentPath}/${mdresource.name}`.replace('//', '/')
          )

          return { ...mdresource, favorite: favorite ?? null }
        }
      )
    },
    filteredReinsuranceResources(): IReinsuranceResource[] {
      if (this.searchText)
        return this.reinsuranceResourcesWithFavorites.filter((x) =>
          x.name?.toLowerCase()?.includes(this.searchText?.toLowerCase())
        )

      return this.reinsuranceResourcesWithFavorites
    },
    filteredSortedReinsuranceResources(): IReinsuranceResource[] {
      return this.filteredReinsuranceResources.slice().sort((a, b) => {
        const aIsY = a.name === "Published in past 30 days";
        const bIsY = b.name === "Published in past 30 days";

      if (aIsY && !bIsY) return 1;
      
      if (!aIsY && bIsY) return -1;
        return a.name.localeCompare(b.name)
      })
    },

    filteredSortedReinsuranceResourcesFiles(): IReinsuranceResource[] {
      return this.filteredSortedReinsuranceResources.filter(
        (x) => !x.isDirectory
      )
    },
    ...mapState(['user']),
  },
  mounted: async function () {
    if (this.$attrs.path) {
      this.currentPath = this.$attrs.path || '/'
      let accumulator = ''
      for (const segment of this.currentPath
        .split('/')
        .filter((x) => x.length > 0)) {
        accumulator += '/' + segment
        this.routes.push({ id: accumulator, name: segment })
      }
    }
    this.reinsuranceResources = await (this.currentPath
      ? await fetch(`/api/reinsuranceresources?path=${encodeURIComponent(this.currentPath)}`)
      : await fetch(`/api/reinsuranceresources`)
    ).json()
    this.favorites = await (
      await fetch(
        '/api/favorites?' +
          new URLSearchParams({ reinsuranceResourcesOnly: 'true' })
      )
    ).json()
    this.loading = false
  },
  components: {
    ScreenTile,
    ResourceDirectoryTile,
    ResourceRow,
    Breadcrumbs,
  },
})
